"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerInterface = void 0;
const preact_1 = require("preact");
const Root_1 = require("./Root");
class PlayerInterface {
    constructor(game, rootNode) {
        this.game = game;
        this.rootNode = rootNode;
    }
    getRootNode() {
        return this.rootNode;
    }
    draw() {
        (0, preact_1.render)((0, preact_1.h)(Root_1.Root, { game: this.game, root: this.rootNode }), this.rootNode);
    }
}
exports.PlayerInterface = PlayerInterface;
